import $ from 'jquery'

$(document).on(
  'click',
  '[data-behaviour="documents-actions-dropdown"]',
  function (_) {
    const selectedElements = $("[name='permanent_entries_select']:checked")

    if (selectedElements.length > 0) {
      $('[data-behaviour="documents-action"]').addClass('sf-display-none')
      $('[data-behaviour="documents-batch-action"]').removeClass(
        'sf-display-none'
      )

      const types = selectedElements
        .map(function () {
          return $(this).data('document-type')
        })
        .get()
      const downloadAction = $("[data-action-type='batch-download']")

      downloadAction.removeClass('sf-display-none')

      if (
        !types.every(
          (type) => type === 'PermanentDocument' || type === 'PermanentCategory'
        )
      ) {
        downloadAction.addClass('sf-btn-disabled')
      } else {
        downloadAction.removeClass('sf-btn-disabled')
      }

      $("[data-action-type='batch-download']").removeClass('sf-display-none')
    } else {
      $('[data-behaviour="documents-action"]').removeClass('sf-display-none')
      $('[data-behaviour="documents-batch-action"]').addClass('sf-display-none')
      $("[data-action-type='batch-download']").addClass('sf-display-none')
    }
  }
)
